import { areOrderTicketRequestsEqual } from '../../utils/tickets/order-ticket-request-utils';
import { getOrderShowtimeById } from '../showtimes/get-order-showtime-by-id';
/**
 * Returns the currently selected tickets for a given showtime.
 */
export const getOrderTicketsForShowtime = (showtimeId, ticket) => {
    var _a, _b;
    const selectedTickets = (_b = (_a = getOrderShowtimeById(showtimeId)) === null || _a === void 0 ? void 0 : _a.tickets) !== null && _b !== void 0 ? _b : [];
    return ticket ? selectedTickets.filter(t => areOrderTicketRequestsEqual(ticket, t)) : selectedTickets;
};
